import header from './header'
import innovationField from './innovation-field'
import innovationProject from './innovation-project'
import macrotrend from './macrotrend'
import posts from './posts'

export default {
    header,
    innovationField,
    innovationProject,
    macrotrend,
    posts
}
